module.exports = __webpack_public_path__ + "img/cartotrade-rotate.e0058f39.svg";